import React from 'react';

const services = [
  {
    icon: '🌎',
    title: 'North America Consulting',
    description: 'Strategic technology consulting and digital transformation services tailored for North American markets.',
    href: '#north-america',
    color: 'from-blue-500 to-blue-700',
  },
  {
    icon: '🧱',
    title: 'Databricks',
    description: 'Lakehouse architecture, data engineering pipelines, and advanced analytics on the Databricks platform.',
    href: '#databricks',
    color: 'from-orange-500 to-red-600',
  },
  {
    icon: '⚡',
    title: 'Power Platform',
    description: 'End-to-end Microsoft Power BI, Power Apps, Power Automate, and Copilot Studio solutions.',
    href: '#power-platform',
    color: 'from-purple-500 to-indigo-600',
  },
  {
    icon: '🤖',
    title: 'AI Consulting',
    description: 'OpenAI GPT-4 and Anthropic Claude strategy, integration, and custom AI solution development.',
    href: '#ai-consulting',
    color: 'from-teal-500 to-cyan-600',
  },
];

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Core Services</h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Specialized expertise across four high-impact technology domains — delivering measurable results for enterprises across North America.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((s, i) => (
            <a
              key={i}
              href={s.href}
              className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow overflow-hidden flex flex-col"
            >
              <div className={`bg-gradient-to-br ${s.color} p-6 text-center`}>
                <span className="text-5xl">{s.icon}</span>
              </div>
              <div className="p-6 flex-grow">
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-primary transition-colors">
                  {s.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">{s.description}</p>
              </div>
              <div className="px-6 pb-5">
                <span className="text-primary font-semibold text-sm group-hover:underline">
                  Learn more →
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
